import React from 'react';
import {connect} from "react-redux";
import RewardClaimComponent from "../components/RewardClaimComponent";
import {withTranslation} from "react-i18next";
import '../style/detail.css';
import SingleRewardClaimComponent from "../components/SingleRewardClaimComponent";

class RewardClaimHistoryContainer extends React.Component {

	componentWillMount() {
		this.props.fetchRewardClaimHistory(this.props.friendlyName);
	}

	render() {
		if(this.props.claims === null || this.props.singleClaim === null)
			return null;

		if(this.props.claims.length === 0){
			return <div></div>;
		}

		const {t} = this.props;
		return <div className="full-height">
			{this.props.singleClaim ? <SingleRewardClaimComponent onClaimClick={() => this.props.raiseRetrieveCodeClickedEvent(this.props.friendlyName, this.props.claims[0].id)}/>
			:<div>
				<div className="claim-history-title">{t('reward.claim.history.title')}</div>
				{this.props.claims.map(claim =>
					<RewardClaimComponent key={claim.id} id={claim.id} orderDate={claim.orderDate} voucherAmount={claim.amount}
										  onVoucherDownload={(orderId, language) => this.props.downloadVouchers(orderId, language)}/>
				)}
			</div>}
		</div>;
	}
}

export default connect (
	(state) => {
		return {
			claims: state.rewardClaimHistory.items,
			singleClaim: state.rewardClaimOptions.item ? state.rewardClaimOptions.item.singleClaim : null
		}
	},
	(dispatch) => {
		return {
			fetchRewardClaimHistory: (friendlyName) => {
				dispatch({
					type: 'FETCH_REWARD_CLAIM_HISTORY',
					friendlyName: friendlyName
				})
			},
			raiseRetrieveCodeClickedEvent: (friendlyName, orderId) => {
				dispatch({
					type: 'RETRIEVE_CODE_CLICKED',
					friendlyName,
					orderId
				})
			}
		}
	}
) ( withTranslation() (RewardClaimHistoryContainer))